import api from '@/api'

const state = {
    sessions: []
}

const actions = {
    getSessionHistoriesAPI({ commit }) {
        return new Promise((resolve, reject) => {
            api.aichat.getSessionHistories().then(
                response => {
                    commit('setSessions', response.data.data)
                    resolve(response)
                },
                error => {
                    reject(error)
                }
            )
        })
    },
    getMessagesAPI({ _ }, sessionId) {
        return new Promise((resolve, reject) => {
            api.aichat.getMessages(sessionId).then(
                response => {
                    resolve(response)
                },
                error => {
                    reject(error)
                }
            )
        })
    },

    sendMessageAPI({ _ }, { payloads }) {
        return new Promise((resolve, reject) => {
            api.aichat.sendMessage(payloads).then(
                response => {
                    resolve(response)
                },
                error => {
                    reject(error)
                }
            )
        })
    }
}

const mutations = {
    setSessions(state, value) {
        state.sessions = value
    },
    prependSession(state, newSession) {
        state.sessions.unshift(newSession)
    }
}

const getters = {
    sessions: state => state.sessions
}

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
}
